import CloserIcon from '../CloserIcon/CloserIcon';
import styles from './CloserButton.module.scss';

type Props = {
  onClick: (e?: any) => void;
  dataTestId?: string;
};

const CloserButton = ({ onClick, dataTestId = 'closeIcon' }: Props) => (
  <button data-testid={dataTestId} className={styles.closer} onClick={onClick}>
    <CloserIcon />
  </button>
);

export default CloserButton;
